import { type Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const sxPaper = {
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  minHeight: '100%',
};

export const sxP20 = {
  p: 2.5,
};

export const sxTab = {
  minWidth: 1,
  flexGrow: 1,
  flexDirection: 'column',
};

export const sxForm = {
  ...sxP20,
  justifyContent: 'space-between',
  minWidth: 1,
  flexGrow: 1,
  flexDirection: 'column',
};

export const sxTrackingNumber = (theme: Theme) => ({
  padding: 2.5,
  borderWidth: 1,
  borderColor: alpha(theme.palette.grey[500], 0.16),
  borderStyle: 'solid',
  borderRadius: 1,
});

export const sxChip = {
  color: 'text.secondary',
  fontWeight: 700,
  fontSize: '12px',
  lineHeight: '20px',
  '& .MuiChip-icon': { fontSize: 16, mr: 0 },
};

export const endAdornmentContainerSx = { display: 'flex', flexDirection: 'row' };
